/**
 * Mortgage Calculator
 *
 * You can changes the default values in config
 *
 * DEV:NOTES
 * Please do not do nay changes in the DO NOT DO ANY CHNAGES block
 * Do import in use project specific import here
 * And play with the render layout structure and keep the params
 */

import React, { useState } from "react";
import PropTypes from "prop-types"
import { Form, Button, Row, Col } from "react-bootstrap"
import Select from "react-select"
import { filterNumber, numberFormat } from "./util"
import {
    calculate,
    countries
} from "@starberry/react-calculator-stampduty"
// import $ from "jquery";

// we could user uk-ireland-stampduty-calculator's propertyTypes & buyerTypes
// but key val par diff we could get valus using Object.values but it is not
// supported in IE - https://caniuse.com/#feat=object-values
// so defined our our custom key pairs

const propertyTypes = [
    {
        value: "residential",
        label: "Residential",
    },
    {
        value: "commercial",
        label: "Commercial",
    },
]

const buyerTypes = [
    {
        value: "first",
        label: "I'm buying my first home or next home",
    },
    {
        value: "investor",
        label: "I'm buying an additional property or second home",
    },
]

// use project specific import here

// DO NOT DO ANY CHNAGES - START
const StampdutyCalc = (props) => {
    const currency = props.currency

    const [result, setResult] = useState(false)

    const [propertyType, setPropertyType] = useState(props.propertyType)
    const [propertyValue, setPropertyValue] = useState(
        currency + numberFormat(filterNumber(props.propertyValue))
    )
    const [buyer, setBuyer] = useState(props.buyerType)

    const formatPrice = str => {
        return currency + str.toLocaleString("en-US")
    }

    const doCalculate = (purchase_price_price) => {
        const results = calculate(
            filterNumber(purchase_price_price ? purchase_price_price : propertyValue),
            propertyType,
            countries.ENGLAND,
            buyer
        )
        // effective stamp duty rates
        // Formula => ((tax / price) * 100).
        // Ex: (213750/2500000) * 100 = 8.55%.
        let effectiveRate = (results.tax / filterNumber(propertyValue)) * 100
        effectiveRate = new Intl.NumberFormat("en-US", {}).format(effectiveRate)
        let summaryBands = []
        results.summaryBands.map(result => {
            summaryBands.push(
                result.adjustedRate +
                "% between " +
                formatPrice(result.start) +
                " and " +
                formatPrice(result.end)
            )
        })
        const result = {
            effectiveRate: effectiveRate + "%",
            summaryBands: summaryBands,
            tax: formatPrice(results.tax),
        }
        setResult(result)
    }

    const handleSubmit = event => {
        event.preventDefault()
        event.stopPropagation()
        doCalculate()
        var shareurl = typeof window !== 'undefined' ? window.location.href : ''
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Stampduty calculator',
            'formType': shareurl,
            'formId': 'Stampduty calculator',
            'formName': 'Stampduty calculator',
            'formLabel': 'Stampduty calculator'
        });
    }

    const handleDeposit = event => {
        var purchase_price_price = currency + numberFormat(filterNumber(event.target.value));
        // doCalculate(purchase_price_price);
        setPropertyValue(purchase_price_price)
    }

    const handlePropertyType = event => {
        setPropertyType(event.target.value)
    }

    const handleBuyer = event => {
        setBuyer(event.target.value)
        // setTimeout(function () {
        //     $('.btn-stamp-calculate').click();
        // }, 300);
    }

    // DO NOT DO ANY CHNAGES - END
    //console.log('propertyValue',propertyValue)
    // useEffect(() => {
    //     doCalculate()
    //     $('.btn-stamp-calculate').click();
    // }, []);
    return (
        <div className="form mortgate-form">
            <div className='calc-st-wrap'>
                <p className="calc-desc">Calculate how much stamp duty you will have to pay based on the purchase price of the property.</p>
                <div className="form-property-calculator">
                    <Form
                        name="MortgageCalc"
                        noValidate
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >

                        <Row>
                            <Col lg={7}>
                                <Row>
                                    <Col lg={5}>
                                        <div className="custom-selectbox-form selectbox-dropdown">
                                            <Form.Group>
                                                <Form.Label>What type of buyer are you?</Form.Label>
                                                <Select
                                                    options={buyerTypes}
                                                    isSearchable={false}
                                                    classNamePrefix={"select-opt"}
                                                    className="form-control"
                                                    placeholder="Buy"
                                                    value={buyerTypes.find(obj => obj.value === buyer)}
                                                    onChange={e => setBuyer(e.value)}
                                                    components={{
                                                        DropdownIndicator: () => (
                                                            <i className="icon icon-dropdown-arrow"></i>
                                                        ),
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    </Col>
                                    <Col lg={5} className="my-lg-0 my-3">
                                        <input type="hidden" name="bot-field" />
                                        <Form.Group controlId="deposit">
                                            <Form.Label>Property Price</Form.Label>
                                            <div className="form-addon-left form-border form-calc-input">
                                                <Form.Control
                                                    className="form-control"
                                                    required
                                                    type="text"
                                                    name="deposit"
                                                    value={propertyValue}
                                                    placeholder="Purchase Price"
                                                    onChange={handleDeposit}
                                                    maxLength={13}
                                                />
                                                <span></span>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2} className="d-flex align-items-end">
                                        <Button type="submit" className="btn btn-primary-outline">
                                            Calculate
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <div className="form-stamp">
                            {/* <input type="hidden" name="bot-field" />
                            <Form.Group controlId="deposit">
                                <Form.Label>Purchase Price</Form.Label>
                                <div className="form-addon-left form-border">
                                    <Form.Control
                                        className="form-control"
                                        required
                                        type="text"
                                        name="deposit"
                                        value={propertyValue}
                                        placeholder="Purchase Price"
                                        onChange={handleDeposit}
                                        maxLength={13}
                                    />
                                    <span></span>
                                </div>
                            </Form.Group> */}

                            <Form.Group controlId="property_type" className="d-none">
                                {propertyTypes.map((item, i) => {
                                    return (
                                        <Form.Check
                                            key={i}
                                            type="radio"
                                            name="property_type"
                                            id={`default-radio-${i}`}
                                            value={item.value}
                                            label={item.label}
                                            checked={propertyType === item.value}
                                            onChange={handlePropertyType}
                                        />
                                    )
                                })}
                            </Form.Group>

                            {/* <div className="stamp-group">
                                {buyerTypes.map((item, i) => {
                                    return (
                                        <Form.Group controlId="buyer">
                                            <Form.Check
                                                key={i}
                                                type="radio"
                                                name="buyer"
                                                id={`default-buyer-${i}`}
                                                value={item.value}
                                                label={item.label}
                                                checked={buyer === item.value}
                                                onChange={handleBuyer}
                                            />
                                        </Form.Group>
                                    )
                                })}
                            </div> */}

                            {/* <Button type="submit" className="btn btn-pink btn-stamp-calculate">
                                Calculate
                            </Button> */}
                        </div>

                        {/* <div className="total-calculate">
                            <div className="d-flex align-items-center">
                                <span className="calculate-text">Stamp Duty:</span>
                                <span className="calculate-rusult">{result.tax}</span>
                            </div>
                        </div> */}
                        <div className="form-col stamp-duty-results">
                            <Form.Group className="stamp-duty-field">
                                {/* <Form.Label>Your stamp duty will be:</Form.Label>
                                <div className="stamp-calc-amount">{result.tax}</div> */}
                                {result && (
                                    <>
                                        <Form.Label>Your stamp duty will be:</Form.Label>
                                        <div className="stamp-calc-amount">{result.tax}</div>
                                        <p className="stampdutytext">
                                            <div className="stamp-calc-title-sm">You have to pay stamp duty:</div>
                                            {result.summaryBands.map((sm, i) => {
                                                return <div className="stamp-calc-results" key={i}>{sm}</div>
                                            })}
                                            <div className="stamp-calc-results-final">Your effective stamp duty rate is {result.effectiveRate}.</div>
                                        </p>
                                    </>
                                )}
                            </Form.Group>
                        </div>
                    </Form>
                </div>
            </div>
            {result && (
                <div className="alert-success d-none">
                    <div>
                        <h3>
                            Stamp Duty: <strong>{result.tax}</strong>
                        </h3>
                        <p>
                            <span>You have to pay stamp duty:</span>
                            {result.summaryBands.map((sm, i) => {
                                return <span key={i}>{sm}</span>
                            })}
                            <span>
                                Your effective stamp duty rate is {result.effectiveRate}
                            </span>
                            .
                        </p>
                    </div>
                </div>
            )}
        </div>
    )
}

StampdutyCalc.defaultProps = {
    propertyType: `residential`,
    propertyValue: `0`,
    buyerType: `first`,
    currency: process.env.CURRENCY ? process.env.CURRENCY : "£",
}

StampdutyCalc.propTypes = {
    propertyType: PropTypes.string,
    propertyValue: PropTypes.any,
    buyerType: PropTypes.string,
    currency: PropTypes.string,
}

export default StampdutyCalc

